var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 81,
    viewBox: "0 0 76 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5131 3.65712C60.0394 3.25712 59.3815 3.25712 58.9078 3.65712C56.4078 5.72855 49.0262 12.4857 49.0657 20.3571C49.0657 26.7285 53.842 31.9285 59.7236 31.9285C65.6052 31.9285 70.3815 26.7428 70.3815 20.3714C70.3946 12.6143 62.9999 5.74283 60.5131 3.65712Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8859 38.9952C39.2543 38.4619 38.3772 38.4619 37.7456 38.9952C34.4123 41.7571 24.5701 50.7666 24.6228 61.2619C24.6228 69.7571 30.9912 76.6905 38.8333 76.6905C46.6754 76.6905 53.0438 69.7762 53.0438 61.2809C53.0613 50.9381 43.2017 41.7762 39.8859 38.9952Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7477 15.131C14.353 14.7976 13.8048 14.7976 13.41 15.131C11.3267 16.8572 5.17537 22.4881 5.20826 29.0476C5.20826 34.3572 9.18853 38.6905 14.0898 38.6905C18.9912 38.6905 22.9714 34.3691 22.9714 29.0596C22.9824 22.5953 16.8201 16.8691 14.7477 15.131Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.faa8398eddc6afb5cd6c96480dc53cf4.svg";
export { ForwardRef as ReactComponent };